import { Location } from "history";
import { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

export default function useRedirectOnCondition(
  condition: boolean | any,
  redirectLocation: (string | Location) | null | undefined
) {
  const history = useHistory();
  const { pathname } = useLocation();

  const redirectPath =
    typeof redirectLocation === "object" && redirectLocation !== null
      ? redirectLocation.pathname
      : redirectLocation;

  useEffect(() => {
    if (condition && redirectPath && pathname !== redirectPath) {
      history.replace(redirectLocation as string);
    }
  }, [pathname, history, condition, redirectPath, redirectLocation]);
}
